import { Box, MenuItem, Select, Stack, Typography } from "@mui/material";
import { bridgeNetworksConfig } from "modules/bridge/config";
import { Controller, useFormContext } from "react-hook-form";

interface Props {
  label: string;
  name: "chainIdFrom" | "chainIdTo";
  disabled?: boolean;
}

export const NetworkSelect = ({ label, name, disabled }: Props) => {
  const { control, setValue, watch } = useFormContext();

  const values = watch();

  const currentNetwork = bridgeNetworksConfig.find(
    (network) => network.chainId === values.chainIdFrom
  );

  const filteredNetworks =
    name === "chainIdTo"
      ? bridgeNetworksConfig.filter(({ chainId }) =>
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          currentNetwork?.availableChainsTo.includes(chainId)
        )
      : bridgeNetworksConfig;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Box sx={{ width: "100%" }}>
          <Typography variant="body1" marginBottom={1}>
            {label}
          </Typography>
          <Select
            {...field}
            fullWidth
            sx={{
              backgroundColor: "secondary.main",
              ...(disabled ? { border: 0, background: "#ECECEC" } : {}),
            }}
            onChange={(e) => {
              field.onChange(e);
              setValue(name, e.target.value);
            }}
            disabled={disabled}
          >
            {filteredNetworks.map(({ name, logo, chainId }) => (
              <MenuItem value={chainId} key={chainId}>
                <Stack
                  sx={{
                    flexDirection: "row",
                    gap: 2,
                    alignItems: "center",
                  }}
                >
                  {logo}
                  <Typography variant="body1">{name}</Typography>
                </Stack>
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
    />
  );
};
